import React from 'react';
import SolutionGridContainer from "../grid/SolutionGridContainer";
import ScreenContainer from "../../screen/ScreenContainer";
import './Question.scss';

const Question = props => {
  return (
    <section className="SolutionQuestion">
      <div className="QuestionContainer">
        <ScreenContainer/>
      </div>
      <div className="GridContainer">
        <SolutionGridContainer/>
      </div>
    </section>
  );
};

export default Question;
